export default __webpack_public_path__ + "static/media/claypot-chicken-rice.7e0043a3.png";